import { InjectionToken } from '@angular/core';
import { Observable } from 'rxjs';

export const MARKET_SELECTOR_SERVICE_TOKEN = new InjectionToken<MarketSelectorServiceInterface>(
  'MARKET_SELECTOR_SERVICE_TOKEN',
);

export interface Market {
  market_id: string;
  name: string;
}

export interface MarketSelectorServiceInterface {
  marketDropdownOptions$: Observable<Market[]>;
  selectedMarketId$: Observable<string>;
  setSelectedMarketId(marketId: string): void;
}
